import {
  Breakpoints,
  FontFamily,
  PrimaryColors,
} from '@/common/theme/constants';
import { FilterVariant } from '@/widgets/FindAClass/classfinder.interfaces';

import { SxProps } from '@mui/material';

export const filterContainerStyles = (
  filterOpen: boolean,
  variant: FilterVariant
): SxProps => ({
  visibility: 'hidden',
  opacity: 0,
  pointerEvents: 'none',
  position: 'absolute',

  maxHeight: '500px',
  overflow: 'auto',
  color: PrimaryColors.black,
  zIndex: 10,
  top: '100%',
  ...(variant === FilterVariant.Clubs && { right: 0 }),
  ...(variant === FilterVariant.Classes && { left: 0 }),
  width: '100%',
  backgroundColor: PrimaryColors.white,
  padding: '24px 24px 8px',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  ...(filterOpen && {
    visibility: 'visible',
    opacity: 1,
    pointerEvents: 'auto',
  }),

  [`@media screen and (min-width: ${Breakpoints.md}px)`]: {
    maxWidth: '290px',
  },
});

export const applyFilterButtonStyles: SxProps = {
  position: 'sticky',
  bottom: 0,
  width: '100%',
  backgroundColor: 'white',
  padding: '8px 0',
  [`@media screen and (min-width: ${Breakpoints.md}px)`]: {
    padding: '12px 0 24px',
  },
};

export const filterButtonStyles: SxProps = {
  marginBottom: '16px',
  '@media (hover: none)': {
    '&:hover, &:active, &:focus, &:focus-visible': {
      backgroundColor: 'transparent',
      color: 'inherit',
      borderColor: 'inherit',
      boxShadow: 'none',
    },
  },
};

export const clearFilterButtonStyles: SxProps = {
  color: PrimaryColors.black,
  marginBottom: '16px',
  fontFamily: FontFamily.body,
  fontVariantLigatures: 'none',
  fontFeatureSettings: '"liga" 0, "clig" 0',
};

export const closeButtonStyles: SxProps = {
  color: PrimaryColors.black,
  fontSize: '12px',
  position: 'absolute',
  right: '1rem',
  top: '1rem',
  zIndex: 10,
  backgroundColor: 'white',
  borderRadius: '50%',
};

export const filterCountStyles: SxProps = {
  width: '20px',
  height: '20px',
  span: { padding: '0px !important' },
};
